import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { DonutLarge } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import secureLocalStorage from 'react-secure-storage';
import navConfig from "./navConfig";

export default function SidebarList(props) {
    const open = props?.open;

    const navigate = useNavigate();
    const currentPath = window.location.pathname;
    const zedUrl = process.env.REACT_APP_ZED_URL;
    const configs = useSelector((store) => store.configs);

    // Color constants for maintainability
    const colors = { background: '#fffff', listItem: '#fffff', selected: '#dc3545', hover: '#e8e8e8', text: '#666666', icon: '#666666' };
    const sectionHeaderColor = '#9a9a9a';

    const handleNavigate = (path) => {
        navigate(path);
        if (window.innerWidth < 600 && props?.onNavigate) props.onNavigate();
    };

    const handleSwitchToZed = () => {
        try {
            // Get the authentication token from secure storage
            const authToken = secureLocalStorage.getItem('token');

            if (authToken && zedUrl) {
                // Construct the callback URL with token as parameter
                const callbackUrl = `${zedUrl}/ecommerce/callback?token=${encodeURIComponent(authToken)}`;
                window.location.href = callbackUrl;
            } else {
                // Fallback if token is not available
                console.warn('Auth token or Zed URL not available');
                window.location.href = zedUrl;
            }
        } catch (error) {
            console.error('Error switching to Zed:', error);
            window.location.href = zedUrl;
        }
    };


    return (
        <>
            <List sx={{ paddingTop: 2, backgroundColor: colors.background, height: '100%' }}>
                {navConfig.map((section) => {
                    const visibleItems = section.items.filter((item) => !item.flag || configs[item.flag]);
                    if (visibleItems.length === 0) return null;
                    return (
                        <div key={section.section}>
                            <Typography component="div" sx={{ fontFamily: 'Poppins', fontSize: 11, fontWeight: 600, letterSpacing: 0.5, textTransform: "uppercase", color: sectionHeaderColor, px: 2.5, pt: 2, pb: 0.5, opacity: open ? 1 : 0 }}>
                                {section.section}
                            </Typography>
                            {visibleItems.map((item) => {
                                const selected = currentPath === item.path;
                                const Icon = item.icon;
                                return (
                                    <ListItem key={item.path} disablePadding sx={{ display: "block" }}>
                                        <ListItemButton sx={{ minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5, backgroundColor: colors.listItem, '&:hover': { backgroundColor: colors.hover }, '&.Mui-selected': { backgroundColor: colors.listItem } }} onClick={() => handleNavigate(item.path)}>
                                            <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }}>
                                                {item.iconType === "mui" ? (
                                                    <Icon sx={{ color: selected ? colors.selected : colors.icon }} />
                                                ) : (
                                                    <img src={item.icon} alt={item.label} style={{ objectFit: 'contain', filter: selected ? 'invert(27%) sepia(95%) saturate(7480%) hue-rotate(358deg) brightness(103%) contrast(119%)' : 'invert(50%)' }} />
                                                )}
                                            </ListItemIcon>
                                            <ListItemText disableTypography primary={item.label} sx={{ fontFamily: 'Poppins', fontSize: 12, fontWeight: "normal", fontStyle: "normal", textAlign: "left", color: selected ? colors.selected : colors.text, opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </div>
                    );
                })}
                <ListItem key="switch" disablePadding sx={{ display: "block" }}>
                    <ListItemButton sx={{ minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5, backgroundColor: colors.listItem, '&:hover': { backgroundColor: colors.hover }, '&.Mui-selected': { backgroundColor: colors.listItem } }} onClick={handleSwitchToZed}>
                        <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }}>
                            <DonutLarge style={{ color: colors.icon }} />
                        </ListItemIcon>
                        <ListItemText disableTypography primary={"Switch to Zed"} sx={{ fontFamily: 'Poppins', fontSize: 12, fontWeight: "normal", fontStyle: "normal", textAlign: "left", color: colors.text, opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                </ListItem>
            </List >
        </>
    );
}
